import React from "react";
import { Link } from "react-router-dom";
import { FiArrowRight } from "react-icons/fi";
import SEO from "../components/SEO";
import Layout from "../components/Layout";

const NotFound = () => (
  <Layout>
    <SEO title="Page not found" />
    <div className="notfound">
      <div>
        <div className="big">404</div>
        <h2>This page has wandered off.</h2>
        <p style={{ color: "#5b6a7f", maxWidth: 480, margin: "0 auto 2rem" }}>
          The page you were looking for either moved or never existed. Let's get you back somewhere useful.
        </p>
        <Link to="/" className="btn btn--dark">
          Back to home <FiArrowRight />
        </Link>
      </div>
    </div>
  </Layout>
);

export default NotFound;
